import React from "react";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.colors.transparent,
	},
	headerText: {
		paddingBottom: "10px",
		marginBottom: "30px",
		fontFamily: theme.fonts.bold,
		fontSize: "18px",
		lineHeight: "16px",
		letterSpacing: "2px",
		color: theme.palette.colors.darkSlateBlue,
		textTransform: "uppercase",
		position: "relative",
		"&:after": {
			content: "''",
			position: "absolute",
			height: "2px",
			width: "79px",
			bottom: "-9px",
			left: 0,
			backgroundColor: theme.palette.colors.purplishBlue,
		},
	},
	noUnderline: {
		"& $headerText ": {
			"&:after": {
				display: "none",
			},
		},
	},
	isStub: {
		"& $headerText": {
			height: "18px",
			borderRadius: "8px",
			width: "200px",
			backgroundColor: theme.palette.colors.disabled,
			"&:after": {
				display: "none",
			},
		},
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		headerText: {
			"&:after": {
				width: "58px",
			},
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		headerText: {
			fontSize: "16px",
			lineHeight: "16px",
			letterSpacing: "1.8px",
			"&:after": {
				width: "48px",
				bottom: "-8px",
			},
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		headerText: {
			marginBottom: "20px",
			fontSize: "16px",
			lineHeight: "16px",
			"&:after": {
				display: "none",
			},
		},
	},
}));

const HeaderV3 = (props) => {
	let classes = useStyles();

	return (
		<div
			className={classNames(classes.root, {
				[classes.isStub]: props.stub,
			})}
			datatest={props.datatest}
		>
			{props.header && (
				<div
					className={classNames(classes.headerText, {
						[classes.noUnderline]: !!props.noUnderline,
					})}
				>
					{!props.stub && props.header}
				</div>
			)}
		</div>
	);
};

HeaderV3.propTypes = {
	header: PropTypes.string,
	stub: PropTypes.bool,
	datatest: PropTypes.string,
	noUnderline: PropTypes.bool,
	withoutBottomMargin: PropTypes.bool,
};

export default HeaderV3;
